import toDate from './to-date';

export { toDate };

export default toDate;
